// 退款申请列表-详情
export default {
    heard_title: "退款申请",
    tab_single: "项目订单",
    tab_private: "包场订单",
    tab_product: "商品订单",
    // 表单
    fl_no: "输入搜索:",
    fp_no: "服务单号",
    fl_keyword: "联系人:",
    fp_keyword: "姓名/手机号码",
    fl_creatTime: "退款时间:",
    fp_creatTime: "请选择时间",
    // 表格
    tl_orderNo: "订单号",
    tl_userNum: "用户账号",
    tl_amount: "退款金额",
    tl_name: "联系人",
    tl_reason: "退款原因",
    tl_operator: "操作人",
    tl_applyTime: "退款时间",

    // 退款详情
    heard_title2: "服务单详情",
    th_refundItem: "退款项目",
    tl_itemName: "项目名称",
    tl_shop: "商品",
    tl_scheduleCode: "场次",
    tl_size: "规格",
    tl_orderAmount: "价格",
    tl_quantity: "数量",
    tl_discount: "优惠",
    tl_orderPay: "实付",

    // 服务单信息
    th_serveInfo: "服务单信息",
    tl_orderNum: "订单编号",
    btn_view: "查看",
    tl_applyDate: "申请时间",
    tl_refundName: "联系人",
    tl_mobile: "联系电话",
    tl_refundReason: "退款原因",
    tl_refundAmount: "退款金额",
    tl_refundDesc: "退款说明"
};
